/**
 * Helper für Fahrzeug-QR-Codes am Schlüsselkasten (Issue #204).
 *
 * Format: `gutachter-koop://fahrzeug/<uuid>` — wird von Admin generiert,
 * am Schlüsselkasten aufgeklebt und von Mitarbeitern per Kamera gescannt.
 */

export const FAHRZEUG_QR_SCHEME = 'gutachter-koop';
export const FAHRZEUG_QR_HOST = 'fahrzeug';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function buildFahrzeugQRUrl(uuid: string): string {
  return `${FAHRZEUG_QR_SCHEME}://${FAHRZEUG_QR_HOST}/${uuid}`;
}

/**
 * Extrahiert die Fahrzeug-UUID aus einer gescannten QR-URL.
 * Gibt null zurück, wenn das Format nicht zum Fahrzeug-Schema passt
 * oder die ID keine gültige UUID ist. Normalisiert auf lowercase.
 */
export function parseFahrzeugQR(raw: unknown): string | null {
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const prefix = `${FAHRZEUG_QR_SCHEME}://${FAHRZEUG_QR_HOST}/`;
  if (!trimmed.toLowerCase().startsWith(prefix)) return null;
  const rest = trimmed.slice(prefix.length);
  const candidate = rest.split(/[?#/]/, 1)[0] ?? '';
  if (!UUID_RE.test(candidate)) return null;
  return candidate.toLowerCase();
}
